import React, { FocusEvent, useCallback } from "react";
import {
    AutocompleteSaurus,
    retornoAutoComplete,
} from "../autocomplete-saurus/autocomplete-saurus";
import bancos from 'utils/bancos.json';

export interface AutocompleteBancosProps {
    label?: string;
    loadingExterno?: boolean;
    name?: string;
    value?: string;
    error?: boolean;
    helperText?: string;
    placeholder?: string;
    allowSubmit?: boolean;
    disabled?: boolean;
    innerRef?: React.RefObject<HTMLInputElement>;
    onBlur?: (event: FocusEvent<HTMLInputElement>) => any;
    onChange?: (value: retornoAutoComplete) => any;
}

interface BancoProps {
    nomeBanco: string;
    codigo: number;
}

export const AutocompleteBancos = ({
    onChange,
    ...props
}: AutocompleteBancosProps) => {

    const onChangeWrapper = useCallback(
        (value: retornoAutoComplete) => {
            onChange?.(value);
        },
        [onChange]
    );

    const bancosList = (bancos as BancoProps[]).map(banco => ({
        ...banco,
        nomeBanco: `${banco.codigo} - ${banco.nomeBanco}`
    }))


    const valor = bancosList.find(banco => banco.codigo === Number(props.value) as unknown as number);

    return (
        <AutocompleteSaurus
            name={props.name}
            disabled={props.disabled}
            permiteNovo={false}
            loading={props.loadingExterno ?? false}
            opcoes={bancosList}
            optionLabelKey="nomeBanco"
            optionValueKey='codigo'
            onChange={onChangeWrapper}
            onBlur={props.onBlur}
            value={valor?.nomeBanco || ''}
            allowSubmit={props.allowSubmit}
            noOptionsText="Banco não localizado"
            label={props.label}
            helperText={props.helperText}
            error={props.error}
            placeholder={props.placeholder}
            size="small"
            inputRef={props.innerRef}
        />
    );
};
